<template>
  <b-card
    title="Alimentation"
    class="shadow-sm"
  >

    <b-row class="justify-content-between">

      <b-col>
        <div class="d-flex flex-column align-items-start justify-content-center">
          <b-form-checkbox
            v-model="formFood.tubeFeeding.value"
            name="tubeFeeding"
            :value="true"
            :unchecked-value="false"
            @change="$emit('didChangeTubeFeeding', $event)"
          >
            <strong>Alimentation assistée</strong>
          </b-form-checkbox>
        </div>
        <daily-status-card-food-row
          v-for="food in availableFoods"
          :key="food.id"
          :food="food"
          :dailyFood="dailyFoodFor(food)"
          @updateFoodRow="updateFoodRow($event)"
        ></daily-status-card-food-row>
        <b-button variant="outline-secondary" v-b-modal.food-animal-create-modal>
          <plus-icon size="18" class="mr-1" /> Ajouter aliment pour {{animal.name}}
        </b-button>
      </b-col>

      <b-col xl="8" lg="7" md="12">
        <b-form-group
          label-for="foodInformation-input"
          class="mb-0 mt-4 mt-lg-0 w-100 h-100"
          :state="formFood.foodInformation.state"
          :invalid-feedback="formFood.foodInformation.invalidFeedback"
        >
          <b-form-textarea
            id="foodInformation-input"
            class="mt-1 h-100"
            :value="formFood.foodInformation.value"
            @input="$emit('didChangeFoodInformation', $event)"
            placeholder="Informations supplémentaires sur l'alimentation..."
          ></b-form-textarea>
        </b-form-group>
      </b-col>

    </b-row>

    <food-animal-create-modal
      v-if="animal"
      :animal="animal"
      @didSaveFoodAnimal="fetchAvailableFoods"
    ></food-animal-create-modal>

  </b-card>

</template>

<script>
import api from "../../../services/api";
import DailyStatusCardFoodRow from "./DailyStatusCardFoodRow";
import FoodAnimalCreateModal from "../../foodAnimal/FoodAnimalCreateModal";

export default {

  name: "DailyStatusCardFood",

  components: {
    DailyStatusCardFoodRow,
    FoodAnimalCreateModal
  },

  props: {

    animal: {
      type: Object,
      required: true
    },

    formFood: {
      type: Object,
      required: true
    },

    dailyFoods: {
      type: Array,
      required: false
    }
  },

  data(){
    return {
      availableFoods: [],
      selectedFoods: [],
    }
  },

  created () {
    this.fetchAvailableFoods()
  },

  methods: {

    fetchAvailableFoods() {
      api
        .get(`/food?availableForAnimalId=${this.animal.id}`)
        .then(response => {
          this.availableFoods = response.data
        })
    },

    updateFoodRow(row) {

      let index = this.selectedFoods.findIndex(selectedFood => {
        return selectedFood.foodId === row.foodId
      })

      if (index > -1) {
        this.selectedFoods.splice(index, 1)
      }

      if (row.isSelected) {
        this.selectedFoods.push(row)
      }

      this.$emit('didChangeSelectedFoods', this.selectedFoods)
    },

    dailyFoodFor(food) {
      if (!this.dailyFoods) {
        return null
      }
      const res = this.dailyFoods.filter(dailyFood => dailyFood.food.id === food.id)
      return res.length > 0 ? res[0] : null
    }

  }

}
</script>

<style scoped>
.form-group textarea {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/cards/DailyStatusCardFood.vue